import { SVGProps } from 'react';

const SvgCircle5 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-48-384c-11.6 0-21.5 8.3-23.6 19.7l-16 88c-1.2 6.5.4 13.3 4.4 18.6s10 8.8 16.6 9.5l86.9 9.8c15.8 1.8 27.8 15.2 27.8 31.1 0 17.3-14 31.3-31.3 31.3h-36c-11.5 0-22.3-5.7-28.8-15.3l-4.1-6.1c-7.4-11-22.3-13.9-33.3-6.5s-13.9 22.3-6.5 33.3l4.1 6.1c15.4 22.9 41.1 36.6 68.6 36.6h36c43.8 0 79.3-35.5 79.3-79.3 0-40.3-30.3-74.3-70.4-78.8l-61.5-7 7.8-43h84c13.3 0 24-10.7 24-24s-10.7-24-24-24H208z" />
  </svg>
);
export default SvgCircle5;
